import HomeBanner from './HomeBanner.component';
export default HomeBanner;